import style from "./OrderStatusDetail.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import AdminDateChoice from "../datePicker/AdminDateChoice";
import AdminTable from "../table/AdminTable";
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { requester, adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import { useNavigate, useParams } from "react-router-dom";
import { timers } from "jquery";
import TableButton from "../table/TableButton";
import { t } from "i18next";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import P from "components/P";
import ToolTip from "components/tooltip/tooltip";
import { toast } from "react-toastify";
import { getTaxExcelOutput } from "./OrderToExcel";

export const limit = 20;

function OrderCacledTax(props) {
  const [mounted, setMounted] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [type, setType] = useState("single");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const extraCondition = {
    status: "completed",
    payment_status: "captured",
    fulfillment_status: "shipped",
  };
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
    }
  }, [mounted]);
  useEffect(() => {
    adminRequester.getOrderStatus(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setData(result.orders);
        setMaxPage(result.count / limit);
        setCount(result.count);
      }
    );
  }, [page, searchCondition]);
  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getOrderStatus(
        {
          // keyword: keyword,
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setData(result.orders);
          setMaxPage(result.count / limit);
          setCount(result.count);
        }
      );
      setResearch(false);
    }
  }, [research]);
  // useEffect(() => {
  //   let indexes = [];
  //   let outs = [];

  //   indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  //   outs = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  //   setViews(["AllOrder"]);
  //   setExtraCondition([]);

  //   setOuputHeader(outs.map((index) => outputHeaderList[index]));
  //   setTheader(indexes.map((index) => theaderList[index]));
  //   setReset(true);
  // }, [keyword]);

  const theader = [
    {
      width: 130,
      text: "주문일(주문번호)",
      justifyContent: "flex-start",
      Cell: ({ row }) => (
        <VerticalFlex>
          <FlexChild>
            <div style={{ whiteSpace: "nowrap" }}></div>
            <P>{row?.created_at?.slice(0, 16)?.replace("T", " ")}</P>
          </FlexChild>
          <FlexChild>
            <ToolTip
              title={
                <label
                  style={{
                    backgroundColor: "white",
                    zIndex: 10,
                    width: "w-full",
                    padding: 10,
                    borderRadius: 10,
                    cursor: "pointer",
                  }}
                  onClick={async () => {
                    await window.navigator.clipboard.writeText(row.id);
                    toast.success("주문 코드를 복사하였습니다.", {
                      autoClose: 1000,
                      position: "bottom-center",
                    });
                  }}
                >
                  {row.id}
                </label>
              }
            >
              <P
                width={130}
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                ellipsis={true}
                overflow="hidden"
              >
                {row.id}
              </P>
            </ToolTip>
          </FlexChild>
        </VerticalFlex>
      ),
    },
    {
      width: 250,
      text: "사업자정보",
      justifyContent: "flex-start",
      code: "customer",
      Cell: ({ cell }) => (
        <VerticalFlex alignItems="flex-start">
          <FlexChild width="max-content">
            <P>상호 : {cell.businessMutual || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>사업자번호 : {cell.businessNumber || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>주소 : {cell.businessAddress || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>대표자명 : {cell.businessName || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>전화번호 : {cell.businessPhone || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>이메일 : {cell.businessEmail || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>업태 : {cell.businessType || "정보 없음"}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>업종 : {cell.businessDetail || "정보 없음"}</P>
          </FlexChild>
        </VerticalFlex>
      ),
    },
    {
      width: 150,
      text: "주문자",
      code: "customer",
      Cell: ({ cell }) => (
        <VerticalFlex alignItems="flex-start">
          <FlexChild width="max-content">
            <P>{`${cell.first_name} ${cell.last_name}`}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>사업자회원</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>{cell.email}</P>
          </FlexChild>
          <FlexChild width="max-content">
            <P>{cell.phone}</P>
          </FlexChild>
        </VerticalFlex>
      ),
    },
    {
      width: 450,
      text: (
        <HorizontalFlex>
          <FlexChild width={100}>
            <P>입점업체</P>
          </FlexChild>
          <FlexChild width={300}>
            <P>상품정보</P>
          </FlexChild>
          <FlexChild width={50}>
            <P>수량</P>
          </FlexChild>
        </HorizontalFlex>
      ),
      code: "items",
      style: { wordBreak: "break-all" },
      Cell: ({ cell }) => (
        <VerticalFlex alignItems="flex-start">
          {cell?.map((item) => (
            <HorizontalFlex alignItems="flex-start">
              <FlexChild width={100}>
                <P>{item?.variant?.product?.store?.name}</P>
              </FlexChild>
              <FlexChild width={300}>
                <P>{`${item?.variant?.product?.title} ${item?.variant?.title}`}</P>
              </FlexChild>
              <FlexChild width={50}>
                <P>{`${item.quantity}`}</P>
              </FlexChild>
            </HorizontalFlex>
          ))}
        </VerticalFlex>
      ),
    },
    {
      text: "발행일/재발행일",
      code: "metadata",
      Cell: ({ cell }) => {
        if (cell?.published?.created_at) {
          if (cell?.published?.updated_at) {
            return (
              <VerticalFlex width="max_content">
                <FlexChild width="max-content">
                  <P>
                    {cell.published?.created_at
                      ?.slice(0, 16)
                      ?.replace("T", " ")}
                  </P>
                </FlexChild>
                <FlexChild width="max-content">
                  <P>
                    (
                    {cell.published?.updated_at
                      ?.slice(0, 16)
                      ?.replace("T", " ")}
                    )
                  </P>
                </FlexChild>
              </VerticalFlex>
            );
          }
          return cell?.published?.created_at
            ? cell.published?.created_at?.slice(0, 16)?.replace("T", " ")
            : "-";
        }
        return "-";
      },
    },
  ];
  const output = getTaxExcelOutput({
    extraCondition: extraCondition,
    searchCondition: searchCondition,
    onSuccess: () => setResearch(true),
  });
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            <FlexChild width="max-content">
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontSize: 18,
                  paddingBottom: "8px",
                  fontWeight: "700",
                }}
              >
                {t("orderCalcedTax")}
              </div>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={6}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          {type && type === "single" ? (
            <SingleAdminTable
              theader={theader}
              mockData={data}
              initTabIndex={0}
              callback={dataCallback}
              reset={reset}
              research={research}
              count={count}
              page={page}
              maxPage={maxPage}
              setPage={setPage}
              limit={limit}
              output={output}
            />
          ) : (
            <AdminTable theader={theader} mockData={data} initTabIndex={0} />
          )}
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default OrderCacledTax;
